<template>
    <div class="pc-header">
        <!-- 1. 顶部快捷导航 -->
        <div class="top-nav">
            <div class="container">
                <div class="left-nav">
                    <el-link type="text" @click="handleGoHome">进入首页</el-link>
                </div>
                <div class="right-nav">
                    <el-link type="text" @click="handleShowLogin" v-if="!isLogin">登录</el-link>
                    <el-link type="text" v-if="isLogin">{{userInfo.username}}，您好</el-link>
                    <el-link type="text" @click="handleGoUserCenter" v-if="isLogin">个人中心</el-link>
                    <el-link type="text" @click="logout" v-if="isLogin">退出登录</el-link>
                    <el-link type="text" @click="handleShowService">客服中心</el-link>
                </div>
            </div>
        </div>

        <!-- 2. Logo + 搜索栏 -->
        <div class="search-bar">
            <div class="container">
                <div class="logo">
                    <img :src="systemInfo.system_info ? (baseStaticUrl + systemInfo.system_info.web_logo) : '/static/imgs/logo.png'" :alt="systemInfo.system_info ? systemInfo.system_info.web_name : ''" @click="handleGoHome" style="cursor: pointer;" />
                </div>
                <!-- <div class="site-title" v-if="systemInfo.system_info">
                    <div class="site-title-row1">
                        <span class="site-title-main">{{ systemInfo.system_info.web_name_title }}</span>
                        <span class="site-title-sm">{{ systemInfo.system_info.web_name_title_sm }}</span>
                    </div>
                    <div class="site-title-en">{{ systemInfo.system_info.web_name_title_en }}</div>
                </div> -->
                <div class="search-box">
                    <el-input
                        v-model="searchText"
                        placeholder="搜索你想要的课程"
                        class="search-input"
                        size="medium"
                        @keyup.enter.native="handleSearch"
                    >
                        <template #append>
                            <el-button type="primary" icon="el-icon-search" class="search-btn" @click="handleSearch">搜索</el-button>
                        </template>
                    </el-input>
                    <div class="hot-search">
                        <span>热门搜索：</span>
                        <el-link type="text" v-for="item in hotSearchList" :key="item.id" @click="fillSearchText(item.keyword)">{{ item.keyword }}</el-link>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- 登录弹窗 -->
        <el-dialog 
            title="" 
            :visible.sync="showLoginModal" 
            width="420px"
            :close-on-click-modal="false"
            destroy-on-close
            class="custom-login-modal"
        >
            <!-- 自定义弹窗头部 -->
            <div class="login-header">
                <div class="login-title">
                    <i class="el-icon-user-solid login-icon"></i>
                    <span>用户登录</span>
                </div>
                <el-divider direction="horizontal" class="login-divider"></el-divider>
            </div>

            <!-- 登录方式切换（带动画） -->
            <div class="login-type-switch">
                <div 
                    :class="{ active: loginType === 'password' }"
                    @click="switchLoginType('password')"
                    class="switch-item"
                >
                    <i class="el-icon-lock"></i>
                    <span>密码登录</span>
                </div>
                <div 
                    :class="{ active: loginType === 'captcha' }"
                    @click="switchLoginType('captcha')"
                    class="switch-item"
                >
                    <i class="el-icon-sms"></i>
                    <span>验证码登录</span>
                </div>
            </div>

            <!-- 登录表单 + 精细验证 -->
            <el-form 
                :model="loginForm" 
                :rules="loginRules" 
                ref="loginFormRef"
                label-width="0"
                class="login-form"
            >
                <!-- 手机号输入项 -->
                <el-form-item prop="phone" class="form-item">
                    <el-input 
                        v-model="loginForm.phone" 
                        placeholder="请输入11位手机号"
                        maxlength="11"
                        clearable
                        prefix-icon="el-icon-mobile-phone"
                        class="login-input"
                        @input="handleInputClearError('phone')"
                    >
                    </el-input>
                </el-form-item>

                <!-- 密码登录项 -->
                <el-form-item 
                    v-if="loginType === 'password'" 
                    prop="password"
                    class="form-item"
                >
                    <el-input 
                        v-model="loginForm.password" 
                        type="password"
                        placeholder="请输入6-20位登录密码"
                        show-password
                        clearable
                        prefix-icon="el-icon-lock"
                        class="login-input"
                        @input="handleInputClearError('password')"
                    >
                    </el-input>
                </el-form-item>

                <!-- 验证码登录项 -->
                <el-form-item 
                    v-if="loginType === 'captcha'" 
                    prop="captcha"
                    class="form-item"
                >
                    <el-row :gutter="12">
                        <el-col :span="12">
                            <el-input 
                                v-model="loginForm.captcha" 
                                placeholder="请输入4位验证码"
                                maxlength="4"
                                clearable
                                prefix-icon="el-icon-chat-line-round"
                                class="login-input"
                                @input="handleInputClearError('captcha')"
                            >
                            </el-input>
                        </el-col>
                        <el-col :span="12">
                            <el-button 
                                type="primary"
                                :disabled="captchaDisabled"
                                @click="getCaptcha"
                                class="captcha-btn"
                                :loading="captchaLoading"
                            >
                                {{ captchaText }}
                            </el-button>
                        </el-col>
                    </el-row>
                </el-form-item>

                <!-- 记住密码 -->
                <el-form-item class="form-extra">
                    <el-checkbox v-model="loginForm.remember" class="remember-checkbox">记住密码</el-checkbox>
                </el-form-item>

                <!-- 会员须知 -->
                <el-form-item class="form-agree">
                    <el-checkbox v-model="loginForm.agree" class="agree-checkbox">
                        我已阅读并同意
                        <el-button type="text" class="agree-link" @click.stop="openAgreementDialog">《会员须知》</el-button>
                    </el-checkbox>
                </el-form-item>

                <!-- 登录/取消按钮组 -->
                 <div class="login-submit">
                    <el-button 
                        type="primary" 
                        @click="handleLogin"
                        class="login-btn"
                        :loading="loginLoading"
                    >
                        登 录
                    </el-button>
                 </div>
            </el-form>

            <!-- 底部版权/提示 -->
            <div class="login-footer">
                <span class="copyright-text">© {{ Year }} {{ systemInfo.system_info ? systemInfo.system_info.name : '' }} 版权所有</span>
            </div>
        </el-dialog>

        <!-- 会员须知弹窗 -->
        <el-dialog
            title="会员须知"
            :visible.sync="showAgreementDialog"
            width="500px"
            :close-on-click-modal="false"
            append-to-body
        >
            <div class="agreement-content" v-loading="agreementLoading">
                <div v-html="agreementContent"></div>
            </div>
            <div slot="footer">
                <el-button type="primary" @click="() => { loginForm.agree = true; showAgreementDialog = false; }">我已阅读并同意</el-button>
                <el-button @click="showAgreementDialog = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 客服弹窗 -->
        <el-dialog 
            title="" 
            :visible.sync="showServiceModal" 
            width="680px"
            :close-on-click-modal="false"
            destroy-on-close
            class="custom-service-modal"
        >
            <!-- 自定义弹窗头部 -->
            <div class="service-header">
                <i class="el-icon-service service-header-icon"></i>
                <span class="service-header-title">客服中心</span>
                <el-divider direction="horizontal" class="service-divider"></el-divider>
            </div>

            <!-- 客服内容区域（分栏布局：左侧联系方式，右侧二维码） -->
            <div class="service-content">
                <!-- 左侧联系方式 -->
                <div class="service-contact">
                    <div class="contact-item">
                        <i class="el-icon-phone-outline contact-icon"></i>
                        <div class="contact-info">
                            <span class="contact-label">座机电话：</span>
                            <span class="contact-value">{{  systemInfo.system_info ? systemInfo.system_info.contact_information : '' }}</span>
                        </div>
                    </div>
                    <div class="contact-item">
                        <i class="el-icon-mobile-phone contact-icon"></i>
                        <div class="contact-info">
                            <span class="contact-label">手机号码：</span>
                            <span class="contact-value">{{  systemInfo.system_info ? systemInfo.system_info.kf_phone : '' }}</span>
                        </div>
                    </div>
                    <div class="contact-item">
                        <i class="el-icon-user-solid contact-icon"></i>
                        <div class="contact-info">
                            <span class="contact-label">联系客服：</span>
                            <span class="contact-value">{{  systemInfo.system_info ? systemInfo.system_info.customers : '' }}</span>
                        </div>
                    </div>
                    <div class="contact-item">
                        <i class="el-icon-location-outline contact-icon"></i>
                        <div class="contact-info">
                            <span class="contact-label">办公地址：</span>
                            <span class="contact-value">{{  systemInfo.system_info ? systemInfo.system_info.address : '' }}</span>
                        </div>
                    </div>
                    <div class="contact-item">
                        <i class="el-icon-message contact-icon"></i>
                        <div class="contact-info">
                            <span class="contact-label">联系邮箱：</span>
                            <span class="contact-value">{{  systemInfo.system_info ? systemInfo.system_info.email : '' }}</span>
                        </div>
                    </div>
                    <div class="contact-item">
                        <i class="el-icon-time contact-icon"></i>
                        <div class="contact-info">
                            <span class="contact-label">工作时间：</span>
                            <span class="contact-value">{{  systemInfo.system_info ? systemInfo.system_info.work_time : '' }}</span>
                        </div>
                    </div>
                </div>

                <!-- 右侧微信二维码 -->
                <div class="service-qrcode">
                    <div class="qrcode-card">
                        <div class="qrcode-title">微信客服</div>
                        <!-- 替换为你的微信二维码图片地址 -->
                        <img 
                            :src="systemInfo.system_info ? (baseStaticUrl + systemInfo.system_info.weichat) : ''" 
                            alt="微信客服二维码" 
                            class="qrcode-img"
                        >
                        <div class="qrcode-tips">扫码添加客服微信<br>解答您的疑问</div>
                    </div>
                </div>
            </div>

            <!-- 底部关闭按钮 -->
            <div class="service-footer">
                <el-button 
                    type="primary" 
                    @click="showServiceModal = false"
                    class="close-btn"
                >
                    关闭
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { Session } from '@/utils/storage';
import { getHotSearch } from '@/api/home';
import { senSms } from '@/api/sms';
import { login,logout } from '@/api/user';
import { getMemberAgreement } from '@/api/system';
export default {
    name: 'HeaderPc',
    data() {
        // 手机号验证规则
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请输入手机号'))
            }
            const reg = /^1[3-9]\d{9}$/
            if (!reg.test(value)) {
                callback(new Error('请输入正确的11位手机号'))
            } else {
                callback()
            }
        }
        return {
            baseStaticUrl: process.env.VUE_APP_STATIC_URL,
            systemInfo: {},
            isLogin: false,
            userInfo: {},
            Year: '',
            // 弹窗控制
            showLoginModal: false,
            showServiceModal: false,
            showAgreementDialog: false,
            agreementContent: '',
            agreementLoading: false,
            // 登录类型：password-密码登录，captcha-验证码登录
            loginType: 'password',
            // 登录表单数据
            loginForm: {
                phone: '',
                password: '',
                captcha: '',
                remember: false,
                agree: false
            },
            // 表单验证规则
            loginRules: {
                phone: [{ validator: validatePhone, trigger: 'blur' }],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '密码长度为6-20位', trigger: 'blur' }
                ],
                captcha: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                    { len: 4, message: '验证码为4位数字', trigger: 'blur' }
                ]
            },
            // 验证码按钮状态
            captchaDisabled: false,
            captchaLoading: false, // 验证码发送中加载
            // 验证码按钮文字
            captchaText: '获取验证码',
            // 验证码倒计时
            captchaCountdown: 60,
            // 登录加载状态
            loginLoading: false,
            // 搜索相关
            searchText: '',
            hotSearchList: [],
        };
    },
    beforeDestroy() {
    },
    mounted() {
        // 初始化获取Session数据
        this.systemInfo = Session.get('systemConfig') || {};
        this.userInfo = Session.get('userInfo') || {};
        this.Year = new Date().getFullYear();
        this.isLogin = Session.get('token') || false;
        this.getHotSearch();
    },
    methods: {
        // 事件派发：通过$emit触发父组件的方法，实现页面跳转/逻辑执行
        handleGoHome() {
            // 跳转到首页
            // 获取当前路由路径
            const currentPath = this.$route.path;
            // 只有当前不在首页时，才执行跳转
            if (currentPath !== "/") {
                this.$router.push("/");
            }
        },
        handleShowLogin() {
            this.showLoginModal = true;
        },
        // 切换登录方式（带重置）
        switchLoginType(type) {
            this.loginType = type
            // 切换时清空对应表单项，重置表单验证
            if (type === 'password') {
                this.loginForm.captcha = ''
            } else {
                this.loginForm.password = ''
            }
            this.$refs.loginFormRef.clearValidate()
        },
        // 输入时清除对应字段的错误提示
        handleInputClearError(field) {
            this.$refs.loginFormRef.clearValidate(field)
        },
        // 获取验证码
        getCaptcha() {
            // 先验证手机号
            this.$refs.loginFormRef.validateField('phone', (errorMessage) => {
                console.log(errorMessage)
                if (errorMessage) {
                    // 验证失败：errorMessage 是具体的错误提示文字（如"请输入正确的11位手机号"）
                    this.$message.warning(errorMessage)
                } else {
                    senSms({ mobile: this.loginForm.phone, event: 'login' }).then(res=>{
                        if(res.code){
                            this.captchaDisabled = true
                            this.captchaLoading = true
                            this.$message.success('验证码已发送，请注意查收')
                            
                            // 倒计时逻辑
                            const timer = setInterval(() => {
                                this.captchaCountdown--
                                this.captchaText = `${this.captchaCountdown}s后重新获取`
                                if (this.captchaCountdown <= 0) {
                                    clearInterval(timer)
                                    this.captchaDisabled = false
                                    this.captchaLoading = false
                                    this.captchaText = '获取验证码'
                                    this.captchaCountdown = 60
                                }
                            }, 1000)
                        }else{
                            this.$message.error(res.msg || '验证码发送失败')
                            this.captchaDisabled = false
                            this.captchaLoading = false
                            return
                        }
                    })
                }
            })
        },
        // 登录处理
        handleLogin() {
            let that = this;
            // 验证表单
            that.$refs.loginFormRef.validate().then((valid)=>{
                if (!valid) {
                    // 验证失败：errorMessage 是具体的错误提示文字（如"请输入正确的11位手机号"）
                    that.$message.warning('表单填写有误，请核对后重试')
                } else {
                    if (!that.loginForm.agree) {
                        return that.$message.warning('请先阅读并同意《会员须知》')
                    }
                    that.loginLoading = true
                    // 组装登录参数
                    const loginParams = {
                        account: that.loginForm.phone,
                        remember: that.loginForm.remember,
                        // 根据登录类型传对应参数
                        ...(that.loginType === 'password' 
                            ? { password: that.loginForm.password } 
                            : { captcha: that.loginForm.captcha })
                    }
                    login(loginParams).then(res=>{
                        that.loginLoading = false
                        if(res.code){
                            that.$message.success('登录成功')
                            // 登录成功，存储Local
                            Session.set('token', res.data.userinfo.token)
                            Session.set('userInfo', res.data.userinfo)
                            if (that.loginForm.remember) {
                                localStorage.setItem('loginPhone', that.loginForm.phone)
                            }
                            that.isLogin = true;
                            that.userInfo = res.data.userinfo;
                            that.showLoginModal = false
                        }else{
                            that.$message.error(res.msg || '登录失败，账号或密码错误')
                        }
                    }).catch((err) => {
                        that.loginLoading = false
                        that.$message.error('账号或密码错误')
                    })
                }
            })
            .catch((err) => {
                // 捕获异步验证规则的异常（比如远程校验手机号是否存在）
                that.$message.error('验证出错，请稍后重试')
            })
        },
        // 退出登录
        logout(){
            let that = this;
            // 询问是否退出
           that.$confirm('确定要退出登录吗？', '退出确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnClickModal: false
            })
            // 点击“确定”的逻辑
            .then(() => {
                // 调用退出登录接口
                logout().then(res=>{
                    // 方式1：自定义 Session 工具
                    Session.remove('token')
                    Session.remove('userInfo')
                    that.isLogin = false;
                    // 空值保护：避免 res 为 null/undefined 时报错
                    if (res.code) {
                        // 提示成功
                        that.$message.success('退出登录成功！');
                    } else {
                        // 接口返回非成功码的提示
                        that.$message.error(res?.msg || '退出登录失败，请重试');
                    }
                }).catch((err) => {
                    // 提示失败
                    that.$message.error('退出登录失败，请重试');
                })
            })
            // 点击“取消”或关闭弹窗的逻辑
            .catch(() => {});
        },
        openAgreementDialog() {
            this.showAgreementDialog = true;
            if (this.agreementContent) return;
            this.agreementLoading = true;
            getMemberAgreement().then(res => {
                if (res.code) {
                    this.agreementContent = res.data.content;
                }
            }).finally(() => {
                this.agreementLoading = false;
            });
        },
        handleShowService() {
            this.showServiceModal = true;
        },
        handleGoUserCenter() {
            if (this.$route.path !== "/my") {
                this.$router.push("/my");
            }
        },
        // 获取热门搜索关键字
        getHotSearch() {
            let that = this;
            getHotSearch().then(res=>{
                if(res.code){
                    that.hotSearchList = res.data
                }
            })
        },
        // 搜索填充
        fillSearchText(text) {
            const targetRoute = "/search?keyword=" + encodeURIComponent(text);
            if (this.$route.path === '/search' && this.$route.query.keyword === text) {
                return;
            }
            this.$router.push(targetRoute).catch(() => {});
        },
        handleSearch() {
            if (!this.searchText.trim()) {
                this.$message.warning('请输入搜索内容！');
                return;
            }
            const targetRoute = "/search?keyword=" + encodeURIComponent(this.searchText);
            if (this.$route.path === '/search' && this.$route.query.keyword === this.searchText) {
                return;
            }
            this.$router.push(targetRoute).catch(() => {});
        }
    }
};
</script>

<style scoped>
    /* 全局重置 */
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }
    a, .el-link {
        text-decoration: none;
        color: #333;
    }
    .el-link:hover {
        color: #e1251b;
    }
    .container {
        width: 80%;
        margin: 0 auto;
        display: flex;
    }

    /* 顶部快捷导航 */
    .top-nav {
        height: 30px;
        line-height: 30px;
        background-color: #fff;
        border-bottom: 1px solid #f0f0f0;
        font-size: 12px;
    }
    .top-nav .container {
        justify-content: space-between;
    }
    .top-nav .el-link {
        margin: 0 8px;
        font-size: 12px;
        color: #666;
    }
    .top-nav .el-link:hover {
        color: #07A8EA;
    }

    /* 搜索栏 */
    .search-bar {
        padding: 8px 0;
        background: #fff;
        box-shadow: 0 4px 12px rgba(0,0,0,0.06);
    }
    .search-bar .container {
        align-items: center;
        justify-content: space-between;
    }
    .logo {
        max-width: 360px;
        margin-right: 20px;
        flex-shrink: 0;
    }
    .logo img {
        max-width: 100%;
        height: 90px;
        object-fit: contain;
        object-position: left center;
    }
    .site-title {
        flex: 1;
        min-width: 0;
        padding: 0 16px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .site-title-row1 {
        display: flex;
        align-items: baseline;
        gap: 10px;
        overflow: hidden;
    }
    .site-title-main {
        font-size: clamp(20px, 2.4vw, 32px);
        font-weight: 700;
        color: #e1251b;
        white-space: nowrap;
        letter-spacing: 2px;
        flex-shrink: 0;
    }
    .site-title-sm {
        font-size: clamp(11px, 1.1vw, 14px);
        font-weight: 600;
        color: #e1251b;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        letter-spacing: 0.5px;
    }
    .site-title-en {
        font-size: clamp(10px, 0.95vw, 12px);
        font-weight: 400;
        color: #e1251b;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        letter-spacing: 1px;
        margin-top: 10px;
        max-width: 100%;
        opacity: 0.75;
    }
    .search-box {
        margin: 0 20px;
    }
    .search-input {
        /* width: 60% !important; */
    }
    .search-btn {
        width: 80px;
    }
    .hot-search {
        margin-top: 8px;
        font-size: 12px;
        display: flex;
        align-items: center;
    }
    .hot-search span {
        color: #94a3b8;
    }
    .hot-search .el-link {
        margin: 0 6px;
        font-size: 12px;
        color: #888;
    }
    .hot-search .el-link:hover {
        color: #07A8EA;
    }
    .cart-btn {
        margin-left: 20px;
    }

    /* 弹窗整体样式 */
    .custom-login-modal {
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
        overflow: hidden;
    }

    /* 头部样式 */
    .login-header {
        text-align: center;
        padding: 10px 0 0 0;
    }
    .login-title {
        font-size: 20px;
        font-weight: 600;
        color: #1f2937;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;
    }
    .login-icon {
        font-size: 24px;
        color: #1890ff;
        margin-right: 8px;
    }
    .login-divider {
        margin: 0 20px 20px 20px;
        background: #f5f7fa;
    }

    /* 登录方式切换 */
    .login-type-switch {
        display: flex;
        margin: 0 30px 25px 30px;
        border-radius: 8px;
        background: #f8fafc;
        padding: 4px;
    }
    .switch-item {
        flex: 1;
        text-align: center;
        padding: 10px 0;
        border-radius: 6px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s ease;
        color: #666;
        font-size: 14px;
    }
    .switch-item i {
        margin-right: 6px;
        font-size: 14px;
    }
    .switch-item.active {
        background: #1890ff;
        color: #fff;
        box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
    }
    .switch-item:hover:not(.active) {
        color: #1890ff;
        background: #f0f7ff;
    }

    /* 表单样式 */
    .login-form {
        padding: 0 30px;
    }
    .form-item {
        margin-bottom: 20px;
        position: relative;
    }
    .login-input {
        height: 44px;
        border-radius: 8px;
        border: 1px solid #e5e7eb;
        font-size: 14px;
        transition: all 0.2s ease;
    }
    .login-input:hover {
        border-color: #94a3b8;
    }
    .login-input:focus {
        border-color: #1890ff;
        box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
    }
    .login-input ::v-deep .el-input__prefix {
        color: #94a3b8;
        /* left: 14px; */
    }

    /* 验证码按钮 */
    .captcha-btn {
        height: 44px;
        border-radius: 8px;
        font-size: 13px;
        background: #1890ff;
        border: none;
        width: 100%;
    }
    .captcha-btn:disabled {
        background: #94a3b8;
        color: #fff;
    }

    .login-submit{
        margin-bottom: 20px;
    }

    /* 会员须知勾选 */
    .form-agree {
        margin-bottom: 16px;
    }
    .agree-checkbox {
        font-size: 13px;
        color: #666;
        display: flex;
        align-items: center;
    }
    .agree-link {
        padding: 0;
        font-size: 13px;
        color: #1890ff;
        height: auto;
        line-height: 1;
        vertical-align: baseline;
    }
    /* 会员须知内容 */
    .agreement-content {
        max-height: 400px;
        overflow-y: auto;
        padding: 0 4px;
        font-size: 14px;
        color: #555;
        line-height: 1.8;
    }
    .agreement-content h4 {
        color: #1f2937;
        margin: 16px 0 8px;
        font-size: 14px;
    }
    .agreement-content p {
        margin-bottom: 6px;
    }

    /* 表单额外项（记住密码/忘记密码） */
    .form-extra {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 25px;
        font-size: 13px;
    }
    .remember-checkbox {
        color: #666;
    }
    .forgot-pwd-btn {
        color: #1890ff;
        padding: 0;
        font-size: 13px;
    }
    .forgot-pwd-btn:hover {
        color: #096dd9;
        text-decoration: underline;
    }

    /* 按钮组 */
    .form-btn-group {
        display: flex;
        gap: 12px;
        margin-bottom: 20px;
    }
    .login-btn, .cancel-btn {
        flex: 1;
        height: 46px;
        border-radius: 8px;
        font-size: 15px;
        font-weight: 500;
        width: 100%;
    }
    .login-btn {
        background: #1890ff;
        border: none;
    }
    .login-btn:hover {
        background: #096dd9;
    }
    .cancel-btn {
        background: #f5f7fa;
        color: #666;
        border: 1px solid #e5e7eb;
    }
    .cancel-btn:hover {
        background: #e5e7eb;
        color: #333;
    }

    /* 底部版权 */
    .login-footer {
        text-align: center;
        padding: 0 30px 20px 30px;
        font-size: 12px;
        color: #94a3b8;
    }
    .copyright-text {
        letter-spacing: 0.5px;
    }

    /* 适配小屏PC */
    @media (max-width: 450px) {
        .custom-login-modal {
            width: 90% !important;
        }
        .form-btn-group {
            flex-direction: column;
            gap: 8px;
        }
    }

    /* 弹窗整体样式 */
    .custom-service-modal {
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
        overflow: hidden;
    }
    /* 弹窗头部 */
    .service-header {
        text-align: center;
        padding: 10px 0 0 0;
    }
    .service-header-icon {
        font-size: 28px;
        color: #1890ff;
        margin-right: 8px;
    }
    .service-header-title {
        font-size: 22px;
        font-weight: 600;
        color: #1f2937;
    }
    .service-divider {
        margin: 15px 30px 20px 30px;
        background: #f5f7fa;
    }

    /* 内容区域（分栏） */
    .service-content {
        display: flex;
        padding: 0 30px;
        gap: 40px;
        align-items: flex-start;
    }

    /* 左侧联系方式 */
    .service-contact {
        flex: 1;
    }
    .contact-item {
        display: flex;
        align-items: flex-start;
        margin-bottom: 20px;
        padding: 12px 16px;
        background: #f8fafc;
        border-radius: 8px;
        transition: all 0.2s ease;
    }
    .contact-item:hover {
        background: #f0f7ff;
        box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
    }
    .contact-icon {
        font-size: 18px;
        color: #1890ff;
        margin-right: 12px;
        margin-top: 2px;
        flex-shrink: 0;
    }
    .contact-info {
        display: flex;
        flex-wrap: wrap;
    }
    .contact-label {
        color: #666;
        font-size: 14px;
        min-width: 80px;
    }
    .contact-value {
        color: #333;
        font-size: 14px;
        flex: 1;
        word-break: break-all;
    }

    /* 右侧二维码 */
    .service-qrcode {
        width: 200px;
    }
    .qrcode-card {
        text-align: center;
        padding: 20px;
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        background: #fff;
    }
    .qrcode-title {
        font-size: 16px;
        font-weight: 500;
        color: #333;
        margin-bottom: 15px;
    }
    .qrcode-img {
        width: 160px;
        height: 160px;
        border: 1px solid #f5f7fa;
        padding: 8px;
        border-radius: 4px;
    }
    .qrcode-tips {
        font-size: 12px;
        color: #94a3b8;
        margin-top: 15px;
        line-height: 1.5;
    }

    /* 底部关闭按钮 */
    .service-footer {
        text-align: center;
        padding: 20px 30px 30px 30px;
    }
    .close-btn {
        width: 180px;
        height: 44px;
        border-radius: 8px;
        font-size: 15px;
        background: #1890ff;
        border: none;
    }
    .close-btn:hover {
        background: #096dd9;
    }

    /* 适配小屏PC */
    @media (max-width: 768px) {
        .custom-service-modal {
            width: 90% !important;
        }
        .service-content {
            flex-direction: column;
            gap: 20px;
        }
        .service-qrcode {
            width: 100%;
            display: flex;
            justify-content: center;
        }
    }
</style>
